import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';

interface ProviderInfo {
  enabled: boolean;
  healthy: boolean;
  models: Array<{ id: string; default: boolean }>;
  timeout?: number;
}

interface ProviderStatusCardsProps {
  providers: Record<string, ProviderInfo>;
}

const ProviderStatusCards: React.FC<ProviderStatusCardsProps> = ({ providers }) => {
  if (Object.keys(providers).length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>AI Provider 상태</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {Object.entries(providers).map(([name, info]) => (
            <div
              key={name}
              className={`border rounded-lg p-4 ${
                info.healthy ? 'border-green-200 bg-green-50' : 'border-gray-200 bg-gray-50'
              }`}
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-semibold text-gray-900 capitalize">{name}</h3>
                <div className="flex gap-2">
                  <Badge variant={info.enabled ? 'success' : 'default'} className="text-xs">
                    {info.enabled ? 'Enabled' : 'Disabled'}
                  </Badge>
                  <Badge
                    variant={info.healthy ? 'success' : 'error'}
                    className="text-xs"
                  >
                    {info.healthy ? 'Healthy' : 'Offline'}
                  </Badge>
                </div>
              </div>
              <div className="space-y-1">
                {info.models.map((model) => (
                  <div key={model.id} className="flex items-center justify-between text-sm">
                    <span className="text-gray-600 font-mono text-xs">{model.id}</span>
                    {model.default && (
                      <Badge variant="warning" className="text-xs">default</Badge>
                    )}
                  </div>
                ))}
                {info.models.length === 0 && (
                  <p className="text-xs text-gray-400">모델 없음</p>
                )}
              </div>
              {info.timeout && (
                <div className="mt-2 text-xs text-gray-400">Timeout: {info.timeout}s</div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProviderStatusCards;
